export default __webpack_public_path__ + "static/media/zarzadzanie-klientami-1.59798ab7.png";